import React from 'react'
import Creation from './Creation'
import "../pages/PostTimeline.css"

const PostWithStyle = () => {
  return (
    <div className="post-box" >
     <Creation/>
    </div>
  )
}

export default PostWithStyle